import { ThumbDown, ThumbUp, ThumbsUpDown } from '@mui/icons-material';
import { FormattedMessage } from 'react-intl';
import { SENTIMENT } from '../constants';

function getOverallSentimentConfig({ type }) {
  let color = 'info';
  let text = '-';
  let Icon = null;

  if (type === SENTIMENT.POSITIVE) {
    color = 'success';
    text = <FormattedMessage id="POSITIVE" defaultMessage="Positive" />;
    Icon = ThumbUp;
  } else if (type === SENTIMENT.NEGATIVE) {
    color = 'error';
    text = <FormattedMessage id="NEGATIVE" defaultMessage="Negative" />;
    Icon = ThumbDown;
  } else if (type === SENTIMENT.NEUTRAL) {
    color = 'warning';
    text = <FormattedMessage id="NEUTRAL" defaultMessage="Neutral" />;
    Icon = ThumbsUpDown;
  }

  return { color, text, Icon };
}

export default getOverallSentimentConfig;
